import { render, staticRenderFns } from "./History_Index.vue?vue&type=template&id=04969b1c&scoped=true"
import script from "./History_Index.vue?vue&type=script&lang=js"
export * from "./History_Index.vue?vue&type=script&lang=js"
import style0 from "./History_Index.vue?vue&type=style&index=0&id=04969b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04969b1c",
  null
  
)

export default component.exports